import { UserIcon } from 'lucide-react'

import { registerSplitViewContent } from '../../split-view.registry'

import { UserInteractionContentContainer } from './user-interaction-content.container'
import type { UserInteractionContentData } from './user-interaction-content.interface'

const isUserInteractionContentData = (data: unknown): data is UserInteractionContentData =>
  typeof data === 'object' &&
  data !== null &&
  'interaction' in data &&
  typeof (data as UserInteractionContentData).interaction === 'object' &&
  (data as UserInteractionContentData).interaction !== null &&
  'type' in (data as UserInteractionContentData).interaction &&
  (data as UserInteractionContentData).interaction.type === 'user-interaction'

export const registerUserInteractionContent = (): void => {
  registerSplitViewContent<UserInteractionContentData>({
    type: 'user-interaction',
    title: 'Action Required',
    subtitle: (data) => data.interaction.title,
    icon: UserIcon,
    component: UserInteractionContentContainer,
    isValidData: isUserInteractionContentData,
  })
}
